var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSugar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_5088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7957 5.68438C24.9256 4.81425 25.3897 4.35023 24.5195 3.48009C23.6495 2.61007 23.1855 3.07415 22.3155 2.20412C21.4454 1.3341 21.9095 0.870023 21.0394 0L20.9606 0.0788594C19.0385 2.00096 19.0385 5.11733 20.9606 7.03943C22.8827 8.96153 25.9991 8.96153 27.9212 7.03943L28 6.96057C27.1299 6.09055 26.6659 6.55452 25.7957 5.68438Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03943 20.9607C5.11733 19.0386 2.00096 19.0386 0.0788594 20.9607L0 21.0395C0.870023 21.9095 1.33405 21.4455 2.20412 22.3155C3.07415 23.1855 2.61007 23.6496 3.48009 24.5196C4.35023 25.3897 4.81425 24.9257 5.68438 25.7957C6.55452 26.6659 6.09049 27.1299 6.96057 28L7.03943 27.9212C8.96153 25.9991 8.96153 22.8828 7.03943 20.9607Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8005 8.19957C17.574 5.97302 14.3861 5.29457 11.5731 6.16306C14.2638 8.95048 14.5443 11.4706 14.8153 13.9095C15.0724 16.2234 15.3152 18.4089 17.7703 20.864L18.0447 21.1385C18.6732 20.7819 19.2647 20.3363 19.8005 19.8005C23.0041 16.5969 23.0041 11.4031 19.8005 8.19957Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1847 14.0905C12.9276 11.7767 12.6848 9.59113 10.2297 7.13599L9.95527 6.86151C9.32686 7.21807 8.73525 7.66372 8.19953 8.19944C4.99599 11.403 4.99599 16.5969 8.19953 19.8004C10.4261 22.027 13.6139 22.7054 16.4269 21.8369C13.7361 19.0495 13.4557 16.5293 13.1847 14.0905Z",
    fill: "#8D8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_5088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugar);
export default __webpack_public_path__ + "static/media/sugar.4d197202eeefe7337697773b60de5784.svg";
export { ForwardRef as ReactComponent };